module.exports = __webpack_public_path__ + "static/dog-walk-training-4d2e64f5fe583d970beddcf779bafce6.jpg";